import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import Input from 'react-toolbox/lib/input'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import { onEnter } from 'helpers/events'

import sagas from './sagas'

import {
  MODULE_NAME
} from './constants'

import {
  updateName,
  unmount,
  submit
} from './actions'

import {
  nameSelector,
  activeSelector
} from './selectors'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    name: nameSelector(state),
    active: activeSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onEscKeyDown: () => dispatch(unmount()),
    onOverlayClick: () => dispatch(unmount()),
    onChange: (name) => dispatch(updateName(name)),
    onSubmit: () => dispatch(submit()),
    onCancel: () => dispatch(unmount()),
  }
}

class FileRenameDialog extends Component {
  onSubmit = () => this.props.onSubmit()
  onCancel = () => this.props.onCancel()
  onKeyPress = onEnter(this.props.onSubmit)

  actions = [
    { label: 'Cancel', onClick: this.onCancel },
    { label: 'Submit', onClick: this.onSubmit },
  ]

  render() {
    const {
      active,
      onEscKeyDown,
      onOverlayClick,
      name,
      onChange,
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title='Rename'
        theme={styles}
        onOverlayClick={onOverlayClick}
        onEscKeyDown={onEscKeyDown}
        type='small'
      >
        <Input
          type='text'
          label='Please enter a new name for the file'
          value={name}
          onChange={onChange}
          onKeyPress={this.onKeyPress}
        />
      </Dialog>
    )
  }
}

FileRenameDialog.propTypes = {
  active: PropTypes.bool.isRequired,
  onEscKeyDown: PropTypes.func.isRequired,
  onOverlayClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})
const enhance = compose(
  withStyle,
  withSagas,
  withConnect
)

export default enhance(FileRenameDialog)
